import type { FileUploadStatus } from '@/shared/hooks/api/productSource'

export function hasProductSourceFilePath(
  filePathInBucket: string | null | undefined
): boolean {
  return (
    typeof filePathInBucket === 'string' &&
    filePathInBucket.trim().length > 0
  )
}

export function isProductSourceUploadIncomplete(input: {
  fileUploadStatus: FileUploadStatus
  filePathInBucket: string
}): boolean {
  if (input.fileUploadStatus !== 'PENDING') {
    return false
  }
  return !hasProductSourceFilePath(input.filePathInBucket)
}

export function isProductSourceUploadFailed(
  fileUploadStatus: FileUploadStatus
): boolean {
  return fileUploadStatus === 'FAILED'
}

/** True when Lex ingestion (post-upload) is still running. */
export function isProductSourceIngestionInFlight(input: {
  ingestionStatus: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED'
  fileUploadStatus: FileUploadStatus
  filePathInBucket: string
}): boolean {
  if (isProductSourceUploadFailed(input.fileUploadStatus)) {
    return false
  }
  if (isProductSourceUploadIncomplete(input)) {
    return false
  }
  if (input.ingestionStatus === 'PROCESSING') {
    return true
  }
  if (
    input.ingestionStatus === 'PENDING' &&
    input.fileUploadStatus === 'UPLOADED'
  ) {
    return true
  }
  return false
}
